import React from 'react';
import LinearGradient from 'utils/packages/linearGradient';
import { Text, View } from 'react-native';
import { rem } from 'design-system';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const EmojiIcon = ({ children, style, color, onDark, }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    // Always use the custom color for gradients now
    const gradientColors = [
        colors.categories.custom,
        colors.categories.custom,
    ];
    return (<View style={[styles.emojiContainer, onDark && styles.onDark, style]}>
      {color ? (<LinearGradient style={styles.gradient} colors={gradientColors}/>) : null}
      <Text style={styles.emoji}>{children}</Text>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    emojiContainer: {
        height: rem(56),
        width: rem(56),
        backgroundColor: colors.cards.onLight,
        borderRadius: rem(28),
        alignItems: 'center',
        overflow: 'hidden',
        justifyContent: 'center',
    },
    emoji: {
        fontFamily: 'System',
        fontSize: rem(28),
        lineHeight: rem(28) * 1.4,
        color: colors.text.primary,
    },
    gradient: {
        width: '100%',
        height: '100%',
        position: 'absolute',
    },
    onDark: {
        backgroundColor: colors.cards.onDark,
    },
}));
export default EmojiIcon;
